'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

const DEFAULT_REM = 16;
var useRem = (() => {
  if (typeof document !== 'object' || !document.documentElement) {
    return DEFAULT_REM;
  }
  const {
    current: css
  } = React__namespace.useRef(window.getComputedStyle(document.documentElement));
  const fontSizeParsed = parseInt((css.fontSize || '').replace('px', ''), 10);
  return Number.isNaN(fontSizeParsed) ? DEFAULT_REM : fontSizeParsed;
});

exports.DEFAULT_REM = DEFAULT_REM;
exports["default"] = useRem;
